import { accountActivate, accountRisksSettingsEdit, accountUpdate } from "@/redux/account.actions"
/*
ACCOUNT-SCALES
Define risks params for the whole organisations (attributes and scales)
*/
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useRef, useState } from "react"
import RiskScalesConfig from "@/entities/physical-risk/ui/RiskScalesConfig"
import RiskAttributesConfig from "@/entities/physical-risk/ui/modal/RiskAttributesConfig"
import RiskFamiliesConfig from "@/entities/risk-family/ui/RiskFamiliesConfig"
import RpsSurveysConfig from "@/entities/physical-risk/ui/RpsSurveysConfig"
import SaveToast from "@/components/SaveToast"
import { StatusType } from "@/redux/_status.types"
import { sessionEdit } from "@/redux/_session.actions"
import {
  getResidualScaleItems,
  getResidualSettings,
  sortResidualScaleItems
} from "@/entities/physical-risk/utils/sortScales"

export default function RiskScales() {
  const dispatch = useAppDispatch()
  const status = useAppSelector((state) => state.account.status)
  const account = useAppSelector((state) => state.account.active)
  const accountRisksSettings = useAppSelector((state) => state._session.accountRisksSettings)
  const initialAccount = useRef(structuredClone(account))
  const initialSettings = useRef(structuredClone(accountRisksSettings))

  const [isDirty, setIsDirty] = useState(false)

  const handleCancel = () => {
    dispatch(accountActivate(initialAccount.current))
    dispatch(sessionEdit("accountRisksSettings", initialSettings.current))
    setIsDirty(false)
  }

  const handleSave = async () => {
    const { residualRiskScale, residualRiskLevels } = getResidualSettings(
      sortResidualScaleItems(getResidualScaleItems(accountRisksSettings))
    )
    dispatch(accountRisksSettingsEdit({ key: "residualRiskScale", value: residualRiskScale }))
    dispatch(accountRisksSettingsEdit({ key: "residualRiskLevels", value: residualRiskLevels }))
    await dispatch((_, getState) => dispatch(accountUpdate(getState().account.active)))
    initialAccount.current = structuredClone(account)
    initialSettings.current = structuredClone(accountRisksSettings)
    setIsDirty(false)
  }

  return (
    <>
      <RiskScalesConfig onDirty={() => setIsDirty(true)} />
      <RiskFamiliesConfig />
      <RiskAttributesConfig onDirty={() => setIsDirty(true)} />
      <RpsSurveysConfig />
      {isDirty && <SaveToast status={status as StatusType} onCancel={handleCancel} onSave={handleSave} isSaveActive />}
    </>
  )
}
